/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        template: `
void cmd_${NAME}(string data)
{
/****cmd_${NAME}****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
void cmd_${NAME}(string data);`,
    });

    return blocks;
};
